import React, { useEffect } from "react";
import { useState } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import WizButton from "../../../components/wiz/wiz-button";

import "./index.scss";
import Banner from "../../../assets/images/banner.png";
import GustoIcon from "../../../assets/images/gusto-icon.png";
import Logo from "../../../assets/images/boxfox.png";
import RegentLogo from "../../../assets/images/regent-logo.png";
import RegentLogo2 from "../../../assets/images/regent-logo2.png";
import WizBG from "../../../assets/images/wiz-bg.png";
import { useBetween } from "use-between";
import useShopify from "../../../useShopify";
import WizTextfield from "../../../components/wiz/wiz-textfield";
import WizTitle from "../../../components/wiz/wiz-title";
import WizBoxfoxLogo from "../../../assets/images/wiz-boxfox.png";
import GustoLogo from "../../../assets/images/gusto.png";
import PlentyBricks from "../../../assets/images/plenty-bricks.png";

const EDWARDS_APPROVED_EMAILS = [
  
].map(email => email.toLowerCase());

const WIZ_APPROVED_EMAILS = [
"chelsea@wiz.io",
"chelsea1@wiz.io",
"chelsea2@wiz.io",
"chelsea3@wiz.io",
"chelsea4@wiz.io",
"chelsea5@wiz.io",
"chelsea6@wiz.io",
"chelsea7@wiz.io",
"chelsea8@wiz.io",
"chelsea9@wiz.io",
"chelsea10@wiz.io",
]

const Brand = ({ next, form, setForm }) => {
  const [start, setStart] = useState(false);
  const [password, setPassword] = useState("");
  const [pending, setPending] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { campaign, checkEmailOrdered } = useBetween(useShopify);

  const isEncore = campaign.companyId === "65cd150fdc2cf13513530120";
  const is1011 = campaign.companyId === "6530617ad257c395c2f9a961";
  const isLiveNation = campaign.companyId === "65d52364dc2cf135135301fd";
  const isImpiricus = campaign.companyId === "66639212d7476d285f2b1cfe";
  const isRegent = campaign.companyId === process.env.REACT_APP_REGENT_COMPANY_ID;
  const isWiz = campaign.companyId === "67981cfbdca127a271575000";
  const isEdwardsLS = campaign.companyId === "67f6b6badca127a27157640b";
  const isGusto = campaign.companyId === "68140062cee86b5fec95476e";
  const isCyera = campaign.companyId === "6840f57ecee86b5fec9562c6";
  const isKlingAI = campaign.companyId === "68643ac2cee86b5fec9574f1";
  const isNewGusto = campaign.companyId === "68c3332bcee86b5fec9588ab";
  const isPhilo = campaign.companyId === "653186e9d257c395c2f9aaa2";
  const isCyeraSecretSanta2 = campaign.name === "CYERA SECRET SANTA GIFTS";
  const isSynergy = campaign.companyId === "69263137cee86b5fec95fe9a";
  const isPlenty = campaign.companyId === "696aaa2dcee86b5fec96369d";

  const checkEdwardsEmail = (email) => {
    return EDWARDS_APPROVED_EMAILS.includes(email.toLowerCase());
  };

  const checkWizEmail = (email) => {
    return WIZ_APPROVED_EMAILS.includes(email.toLowerCase());
  };

  // useEffect(() => {
  //   console.log("campaign", campaign);
  // }, [campaign]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setPending(true);

    if (isEdwardsLS) {
      if (form.email) {
        const isApproved = await checkEdwardsEmail(form.email);
        if (isApproved) {
          setPending(false);
          next();
        } else {
          setPending(false);
          setErrorMsg("You don't have access to this portal. Please contact your administrator.");
        }
      } else {
        setPending(false);
        setErrorMsg("Please enter your Edwards email");
      }
    } else if (isWiz) {
      if (form.marketingCode && campaign.password === password) {
        if (!form.marketingCode.endsWith("@wiz.io") && !form.marketingCode.endsWith("@gmail.com")) {
          setPending(false);
          setErrorMsg("Invalid Email!!");
          return;
        }
        const isApproved = checkWizEmail(form.marketingCode);
        if (isApproved) {
          // Check if email has already ordered
          const hasOrdered = await checkEmailOrdered(form.marketingCode, campaign._id);
          if (hasOrdered) {
            setPending(false);
            setErrorMsg(
              <span>
                Looks like you already submitted! If you need to make edits or updates, please email{" "}
                <a href="mailto:concierge@shopboxfox.com">concierge@shopboxfox.com</a>
              </span>
            );
            return;
          }
          setPending(false);
          next();
        } else {
          setPending(false);
          setErrorMsg("This portal is now officially closed. Thank you so much for your submissions!");
        }
      } else {
        setPending(false);
        setErrorMsg("This portal is now officially closed. Thank you so much for your submissions!");
      }
    } else {
      if (campaign.password === password) {
        setPending(false);
        next();
      } else {
        setPending(false);
        setErrorMsg("Invalid Password!!");
      }
    }
  };

  // useEffect(() => {
  //   console.log("campaign", campaign);
  // }, []);

  const normalizedCampaignNameForDisplay = (campaign?.name || '').toLowerCase().replace(/[-\s]/g, '');
  const isGrandAsiaCampaign = normalizedCampaignNameForDisplay.includes('grandasia') || normalizedCampaignNameForDisplay.includes('grandasianexploration') || normalizedCampaignNameForDisplay.includes('indianodyssey');
  // World Cruise 2027 drops the split banner layout for a full-width centered one.
  const isWorldCruise2027 = normalizedCampaignNameForDisplay.includes('worldcruise2027');


  return (
    <>
      {Object.keys(campaign).length ? (
        <div
          className={`brand-dashboard
          ${isEncore ? "encore-font" : "default-font"}
          ${isPlenty ? "plenty-mobile" : ""}
          ${isWorldCruise2027 ? "brand-dashboard--centered" : ""}`}
          style={{
            ...(campaign.bgColor ? { backgroundColor: campaign.bgColor } : {}),
            ...(isWiz ? { backgroundImage: `url(${WizBG})`, backgroundSize: "cover", backgroundPosition: "left 25% 50%", minHeight: "100vh", height: "100%" } : {})
          }}
        >
          <div style={isGusto ? { background: "#fff2df" } : isCyera ? { backgroundColor: `#382a50` } : isKlingAI ? { backgroundColor: `#000000` } : null} className={`banner ${isWiz ? 'wiz-banner' : ''}`}>
            { isGusto ? (
               <>
               <img
               style={isGusto ? { objectFit: "contain" } : null}
               className="gusto-banner show-on-desktop"
             src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
             alt="banner"
             />
             <img style={isGusto ? { objectFit: "contain" } : null} className="gusto-logo show-on-mobile" src={GustoLogo} alt="Gusto Logo" />
           </>
            ) : null }
            {isNewGusto ? (
              <div style={{position: "relative", height: "100%", width: "100%"}}>
              <img
                src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
                alt="banner"
                style={{height: "100%", width: "100%"}}
              />
              <img
                src={`${GustoIcon}`}
                alt="banner"
                //center the image in the container
                style={{ width: "320px", height: "320px", display: "block", margin: "auto", position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} 
              />
              </div>
            ) : campaign.loginImage.path && !isGusto ? (
              <img
                src={`${process.env.REACT_APP_API_URL}/${campaign.loginImage.path}`}
                alt="banner"
                style={isRegent ? { backgroundColor: 'white', objectFit: 'contain' } : isKlingAI ? {  objectFit: 'contain' } : null}
              />
            ) : !isGusto ? (
              <img src={Banner} alt="banner" />
            ) : null}
          </div>
          <Container
            style={
              campaign.bgColor ? { backgroundColor: isPhilo ? "black" : campaign.bgColor, alignItems: isWiz && "start", color: isImpiricus ? "white" : null } : null
            }
            className={`brand-actions ${isWiz ? "wiz-padding" : ""}`}
            // if isWiz the align items are start
          >
            <div className="logo">
              {isRegent ? (
                <img
                  style={isWorldCruise2027 ? null : { transform: "scale(0.35)" }}
                  src={
                    // World Cruise 2027 uses the logo uploaded on the campaign.
                    isWorldCruise2027 && campaign.logo.path
                      ? `${process.env.REACT_APP_API_URL}/${campaign.logo.path}`
                      : isGrandAsiaCampaign
                        ? RegentLogo2
                        : RegentLogo
                  }
                  alt="Regent Logo"
                />
              ) : isWiz ? (
                <img
                  style={{ margin: 0, paddingLeft: "36px", maxWidth: "350px" }}
                  src={WizBoxfoxLogo}
                  alt="Wiz and Boxfox Logo"
                />
              ) : isImpiricus ? (
                <img
                style={{ transform: "scale(0.8)" }}
                    src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                    alt="Company Logo"
                  />
              ) : isCyera ? (
                <img
                  style={{ transform: "scale(0.8)" }}
                  src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                  alt="Company Logo"
                />
              ) : isNewGusto ? (
                <img
                  style={{ transform: "scale(0.8)" }}
                  src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                  alt="Company Logo"
                />
              ) : isPhilo ? null : (
                <img
                  className={`${isEncore ? "white-logo" : ""}`}
                  src={Logo}
                  alt="logo"
                />
              )}
            </div>
            {!start ? (
              <>
                <div className="company-logo" style={ isImpiricus ? { display: "none" } : isWiz ? { margin: "16px 0px" } : null }>
                {isRegent ? null : isWiz ? (
                  <WizTitle />
                ) : isNewGusto ? null : isGusto ? null : isCyera ? null : (
                campaign.logo.path ? (
                  <img
                    style={ isImpiricus ? { display: "none" } : null }
                    src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                    alt="Company Logo"
                  />
                ) : null
              )}
                </div>
                {isImpiricus && (
                  <h2
                    style={{
                      color: "white",
                      fontFamily: "monospace",
                      letterSpacing: "0.1em",
                      width: "100%",
                      textAlign: "center",
                      margin: "24px 0",
                    }}
                  >
                    RFP SURVIVAL KIT
                  </h2>
                )}
                <p
                  style={
                    isWiz ? { marginBottom: "24px", color: campaign.textColor ? campaign.textColor : null } : campaign.textColor ? { color: campaign.textColor } : null
                  }
                  className="brand-desc"
                >
                  {is1011 ? (
                    <p>Ten Eleven Ventures would like to send you a gift!</p>
                  ) : isEncore ? (
                    <p>Ready to receive a gift from Encore?</p>
                  ) : isLiveNation ? (
                    <p>Enter the Client Gifting Portal</p>
                  ) : isCyeraSecretSanta2 ? (
                    <p>
                      <b>Welcome to the second part of the Cyera Claus Exchange!</b><br></br>
                      You entered the Cyera Claus Exchange, now pick out your Secret Santa gift to ship across the world for your recipient!</p>
                  ) : isCyera ? (
                    <p>
                      <b>Welcome to the Cyera Claus Exchange!</b><br></br>
                      Share your shipping details and a little bit about yourself. Your Secret Santa will use this to help choose a surprise just for you.<br></br>Join in, connect with teammates around the world, and make this holiday season unforgettable!</p>
                  ) : (
                    <p style={ isWiz ? { marginBottom: "0px", textAlign: "left" } : null }>
                      {campaign.customBodyText
                        .split("<br>")
                        .map((text, index) => (
                          <React.Fragment key={index}>
                            {text}
                            {index <
                              campaign.customBodyText.split("<br>").length -
                                1 && <br />}
                          </React.Fragment>
                        ))}
                    </p>
                  )}
                </p>
                {isWiz ? (
                  <div style={{width: "100%", display: "flex", alignItems: "left", justifyContent: "left"}}>
                  <WizButton style={{maxWidth: "392px"}} onClick={() => {
                    setStart(true);
                  }} >Get Started</WizButton>
                  </div>
                ) : (
                  <Button
                    style={{
                    backgroundColor: campaign.buttonColor || null,
                    color: campaign.buttonTextColor || null,
                    border:
                      (campaign.buttonStrokeColor &&
                        `2px solid ${campaign.buttonStrokeColor}`) ||
                      null,
                  }}
                  className={`mb-4`}
                  onClick={() => {
                    if (isRegent) {
                      next();
                    } else if (isSynergy) {
                      next();
                    } else {
                      setStart(true);
                    }
                  }}
                >
                  {isImpiricus ? "Claim Gift" : isGusto ? "Welcome to Gusto" : isNewGusto ? "OPT IN FOR YOUR END OF YEAR GIFT" : "Get Started"}
                  </Button>
                )}
              </>
            ) : (
              <>
                <div className="company-logo mb-0" style={ isImpiricus ? { display: "none" } : null }>

                  { isWiz ? (
                    <WizTitle />
                  ) : isGusto | isNewGusto ? (
                    null
                  ) : isCyera ? (
                    null
                  ) : campaign.logo.path ? (
                    <img
                      style={ isImpiricus ? { display: "none" } : null }
                      src={`${process.env.REACT_APP_API_URL}/${campaign.logo.path}`}
                      alt="Company Logo"
                    />
                  ) : null}
                </div>
                {isImpiricus && (
                  <h2
                    style={{
                      color: "white",
                      fontFamily: "monospace",
                      letterSpacing: "0.1em",
                      width: "100%",
                      textAlign: "center",
                      margin: "24px 0",
                    }}
                  >
                    RFP SURVIVAL KIT
                  </h2>
                )}
                <p
                  // if the company is #6530617ad257c395c2f9a961, then the text color is bgColor otherwise it is textColor or null
                  style={{
                    display: is1011 || isWiz ? "none" : "block",
                    color: isPhilo ? "white" : campaign.textColor || null,
                    ...(isImpiricus ? { marginTop: 0 } : {}),
                  }}
                  className="brand-desc pwd"
                >
                  {isEncore
                    ? "Please enter the password provided in the email here."
                    : isEdwardsLS 
                    ? "Please enter your company email below to redeem gifts." 
                    : isImpiricus ? "Please enter the password provided to select and redeem your RFP Survival Kit!" : isNewGusto ? "Enter your secret password below." : isPhilo ? "Please enter your password to redeem your gift below." : isPlenty ? "Enter the password sent via email from Plenty." : "Please enter your company corporate gifting password below."}
                </p>
                {campaign.companyId === "6530617ad257c395c2f9a961" && (
                  <p
                    className="brand-desc pwd"
                    style={{ color: campaign.textColor || null }}
                  >
                    Sending our thanks for our partnership this year!
                  </p>
                )}
                <Form
                  className="w-100"
                  onSubmit={(event) => {
                    handleSubmit(event);
                  }}
                >
                  <Form.Group className="company-login">
                    { isEdwardsLS ? (
                      <Form.Control
                        type="email"
                        value={form.email}
                        onChange={(event) => {
                          setErrorMsg("");
                          setForm({ ...form, email: event.target.value });
                        }}
                        placeholder="Edwards Email"
                        required
                      />
                    ) : isWiz ? (
                      // flex column with gap 10px
                      <div className="d-flex flex-column gap-3">
                        <WizTextfield
                          type="email"
                          placeholder="Company Email"
                          value={form.marketingCode}
                          onChange={(event) => {
                            setErrorMsg("");
                            setForm({ ...form, marketingCode: event.target.value });
                          }}
                        />
                        <WizTextfield
                          type="password"
                          placeholder="Enter Password"
                          value={password}
                          onChange={(event) => {
                            setErrorMsg("");
                            setPassword(event.target.value);
                          }}
                        />
                      </div>
                    ) : (
                      <Form.Control
                        type="password"
                        value={password}
                        onChange={(event) => {
                          setErrorMsg("");
                          setPassword(event.target.value);
                        }}
                        placeholder="Password"
                        required
                      />
                    )}
                    <p className="error">{errorMsg}</p>
                  </Form.Group>
                  {campaign.loginText ? (
                    <p
                      style={{
                        color: campaign.textColor || null,
                        textAlign: isWiz ? "left" : null,
                      }}
                    >
                      {campaign.loginText}
                    </p>
                  ) : null}
                  {isWiz ? (
                    <div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <WizButton style={{maxWidth: "392px"}} children={!pending ? (
                      "Continue"
                    ) : (
                      <Spinner animation="border" />
                    )}  type="submit" onClick={(event) => {
                      handleSubmit(event);
                    }}>Continue</WizButton>
                    </div>
                  ) : (
                    <Button
                      className="mb-4"
                    style={{
                      backgroundColor: campaign.buttonColor || null,
                      color: campaign.buttonTextColor || null,
                      border:
                        (campaign.buttonStrokeColor &&
                          `2px solid ${campaign.buttonStrokeColor}`) ||
                        null,
                    }}
                    type="submit"
                  >
                    {/* if not pending, if the company is #123 then text is Continue if not then Next, if pending then spinner*/}
                    {!pending ? (
                      campaign.companyId === "6530617ad257c395c2f9a961" ? (
                        "Continue"
                      ) : (
                        "Next"
                      )
                    ) : (
                      <Spinner animation="border" />
                    )}
                    </Button>
                  )}
                </Form>
              </>
            )}
          </Container>
          {isPlenty && (
            <img
              src={PlentyBricks}
              alt="Plenty decoration"
              style={{
                position: "absolute",
                bottom: "-15px",
                right: "-15px",
                width: "420px",
                height: "auto",
                pointerEvents: "none"
              }}
            />
          )}
        </div>
      ) : null}
    </>
  );
};

export default Brand;
